'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';
import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PaginationPluto from './Pagination';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';


function PlutoSupportList() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    useEffect(() => {
        socket.on('response_get_admin_users_support', (data) => {
            setEarnings(data.users)
            setPageNumber(Math.ceil(data.usersLength2 / 10))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)
            setUserId(data.user_id)

        })
        socket.emit('getUsersSupportAdmin', {
            username_like: username,
            page,
        })
    }, [])

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>
                {/* Stats Card */}
                <div style={{ marginBottom: '24px' }}>
                    {userProfile.usersLength2 != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #f97316',
                            borderRadius: '12px',
                            padding: '16px 20px',
                            display: 'inline-block'
                        }}>
                            <p style={{ fontSize: '24px', fontWeight: '700', color: '#e6edf3' }}>
                                {numberWithCommas(userProfile.usersLength2)}
                            </p>
                            <p style={{ fontSize: '11px', fontWeight: '600', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Unresolved</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Table Card */}
                <div style={{
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '20px'
                }}>
                    <div style={{ padding: '16px 20px', borderBottom: '1px solid #21262d' }}>
                        <p style={{ color: '#e6edf3', fontWeight: '600', fontSize: '16px' }}>Support Tickets</p>
                    </div>

                    {/* Table Header */}
                    <div style={{ borderBottom: '1px solid #21262d', background: '#161b22' }}>
                        <div className="user-details-table-elements" style={{ fontWeight: '600' }}>
                            <div style={{ minWidth: '50px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Chat ID</div>
                            <div style={{ minWidth: '50px', textAlign: 'left', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>User ID</div>
                            <div style={{ minWidth: '100px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Last Message</div>
                            <div style={{ minWidth: '100px', textAlign: 'right', maxWidth: '100px', fontSize: '11px', color: '#8b949e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Action</div>
                        </div>
                    </div>

                    {/* Table Rows */}
                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{
                                color: '#c9d1d9',
                                borderBottom: '1px solid #21262d',
                                border: earning.locked_for == userId ? '1px solid #d29922' : '',
                                borderBottom: earning.locked_for == userId ? '1px solid #d29922' : '1px solid #21262d'
                            }}>
                                <div style={{ minWidth: '50px', color: '#e6edf3' }}>{earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', textAlign: 'left', color: '#58a6ff' }}>{earning.user_id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px', color: '#8b949e' }}>{earning.last_msg_time || <Skeleton style={{ width: '30px' }} />}</div>

                                <Link to={`/pluto/support-chat/${earning.id}`} style={{
                                    minWidth: '100px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    maxWidth: '100px',
                                    background: '#238636',
                                    border: '1px solid #2ea043',
                                    borderRadius: '6px',
                                    color: '#ffffff',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                }} onClick={() => {
                                    if (earning.id != undefined) {
                                        socket.emit('lockChatAdmin', {
                                            chat: earning.id
                                        })
                                    }
                                }}>{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Respond'}</Link>

                            </div>
                        )
                    })}
                </div>
                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                    socket.emit('getUsersAdmin', {
                        username_like: username,
                        page,
                    })
                }} />}

            </div>

        </SkeletonTheme>
    )
}

export default PlutoSupportList
